export default "__VITE_ASSET__B0qRxrb0__"